import type {
  ApiKey,
  ApiKeyRuleDto,
  ApiKeyRulesDto,
  CreateApiKeyDto,
  CreateApiKeyResponseDto,
} from '@carvia/ros-client-types';
import { httpClient } from './http-client';

class ApiKeysService {
  private endpoint = '/api-keys';

  async listByUserId(userId: string): Promise<ApiKey[]> {
    const res = await httpClient.get<ApiKey[]>(`${this.endpoint}/user/${userId}`);
    return res.data;
  }

  async listAll(): Promise<ApiKey[]> {
    const res = await httpClient.get<ApiKey[]>(`${this.endpoint}`);
    return res.data;
  }

  async create(data: CreateApiKeyDto): Promise<CreateApiKeyResponseDto> {
    const res = await httpClient.post<CreateApiKeyResponseDto>(`${this.endpoint}`, data);
    return res.data;
  }

  async updateRules(id: string, data: ApiKeyRulesDto): Promise<ApiKey> {
    const res = await httpClient.patch<ApiKey>(`${this.endpoint}/${id}/rules`, data);
    return res.data;
  }

  async delete(id: string): Promise<void> {
    await httpClient.delete<void>(`${this.endpoint}/${id}`);
  }
}

export const apiKeysService = new ApiKeysService();
